/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto } from '../../models/user-dto';

export interface SuperAdminsControllerGetSuperAdminUsers$Params {

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
}

export function superAdminsControllerGetSuperAdminUsers(http: HttpClient, rootUrl: string, params?: SuperAdminsControllerGetSuperAdminUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
  const rb = new RequestBuilder(rootUrl, superAdminsControllerGetSuperAdminUsers.PATH, 'get');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserDto>>;
    })
  );
}

superAdminsControllerGetSuperAdminUsers.PATH = '/api/v1/users/super-admins';
